import { YYYY_MM_DD_HH_mm_ss } from "@beable/mwm-commons-date-time"
import { AuthenticationAdminResponse, CustomerDTO, Environments, GetSitePauseDatesResponse, Roles, SiteDTO, SiteIntegrationMethodEnum, SiteIntegrationTypeEnum, SiteTypes } from "@beable/roster-backend-client-v1"

export const emptySSOProvider = {
    id: '',
    name: '',
    environment: Environments.qa,
    customerIdentifier: '',
    userIdentifier: '',
    userIdentifierAccessor: '',
    redirectUrl: ''
}

export const ssoProviderValidation = {
    name: true,
    customerIdentifier: true,
    userIdentifier: true,
    userIdentifierAccessor: true,
    redirectUrl: true
}

export const LTIPlatformValidation = {
    name: true,
    issuer: true,
    deploymentId: true,
    clientId: true,
    siteId: true,
    keyset: true,
    keysetUrl: true,
    userLookupField: true,
    logoutRedirectUrl: true,
    identifierTransforms: true,
    active: true,
    authRedirectUrl: true
}

export const emptySSOProviderSite = {
    id: '',
    siteId: 0,
    identifier: '',
    providerId: '',
    active: true,
    siteName: '',
    providerValidation: 'N/A',
    providerValidationString: 'N/A',
}

export const customerListFixture = (): CustomerDTO[] => {
    const customers = [
        {
          id: "e27d9770-c2a7-11ea-a961-555188b9a471",
          licenseCount: 10250,
          locationCode: "US-CA",
          name: "New School District",
          studentEnrollment: 2100,
          totalSchools: 2,
          url: "https://www.new.org/",
        },
        {
          id: "2a3da680-ba43-11ea-9eda-dd1cab6d94fd",
          licenseCount: 10925,
          locationCode: "US-CA",
          name: "Yavor Test School",
          studentEnrollment: 16643,
          totalSchools: 28,
          url: "https://www.yavor.net/",
        },
        {
          id: "5a3da680-ba43-11ea-9eda-dd1cab6d94fd",
          licenseCount: 100,
          locationCode: "US-NJ",
          name: "NJ School",
          studentEnrollment: 500,
          totalSchools: 10,
          url: "https://www.njschool.org/",
        },
      ];
    return customers;      
}

export const siteListFixture = (): SiteDTO[] => {
    const sites = [
        {
          customerId: "e27d9770-c2a7-11ea-a961-555188b9a471",
          customerName: "CustomerName 1",
          id: 10085,
          integrationMethod: SiteIntegrationMethodEnum.Manual,
          integrationType: SiteIntegrationTypeEnum.OneRosterCSV,
          subdomain: "antontest3",
          timezone: "US/Central",
          leaid: "leaid",
          type: SiteTypes.demo,
          allowPasswordChange: false,
        },
        {
          customerId: "f27a27c1-c29c-11ea-827d-2d367a020204",
          customerName: "CustomerName 2",
          id: 10086,
          integrationMethod: SiteIntegrationMethodEnum.Manual,
          integrationType: SiteIntegrationTypeEnum.OneRosterCSV,
          subdomain: "antontest4",
          timezone: "US/Central",
          leaid: "leaid",
          type: SiteTypes.qa,
        },
      ];
    return sites;      
}

export const pauseDatesFixture = ():  GetSitePauseDatesResponse => {
  const pauseDates = {
    optionId: 'abcdefg',
    siteId: 10085,
    pauseDates: [
      {
        startDate: new YYYY_MM_DD_HH_mm_ss("2020-08-10 00:00:00"),
        endDate: new YYYY_MM_DD_HH_mm_ss("2020-08-10 23:59:59"),
        active: true
      }
    ]
  };
  return pauseDates;
}

export const adminUserFixture = (role?: Roles): AuthenticationAdminResponse => {
  return {
    "id": "833bdca0-7d31-11eb-9d5d-a767e1825dfs",
    "username": "admin",
    "email": "admin@beable.com",
    "role": role || Roles.beableadmin,
    "customerId": "833bdca0-7d31-11eb-9d5d-a767e1825dff"
  };
}